const cropApplication = [
    {
        "id": "1",
        "createdOn":"2020-01-20T08:20:10.000Z",
        "stayDays": 5,
        "appNo":"CGA00150-C-00-001",
        "type":"initial",
        "farmerNo":"CGA00150",
        "appStatus": "close",
        "farmerName":"王森林",
        "phone": "03-2912-1292",
        "mobilePhone": "0912123321",
        "greenConservationLiaison": "王小保",
        "cropApplication": {
            "id":"1",
            "applicant":"王森林",
            "idNo": "A123456789",
            "farmName": "興興",
            "applicantType": "individual",
            "gender": "male",
            "birthday": "1979/03/23",
            "phone": "03-2912-1292",
            "contactPerson": "王大濃",
            "farmType": ["production"],
            "applyApprovedProcessing": true,
            "contactPersonPhone": "0912123321",
            "conservationTarget": "species2",
            "species": "青蛙",
            "category":"crop",
            "type":"initial",
            "createdOn":"2021-05-12T08:20:10.000Z",
            "totalImplementationArea":1.1678,
            "nonGreenArea": 0.345,
            "fieldLands":[
                {
                    "id":"1",
                    "fieldNo":"F01",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"249",
                    "actualCultivatedArea":0.2968
                },
                {
                    "id":"2",
                    "fieldNo":"F02",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"246",
                    "actualCultivatedArea":0.0305
                },
                {
                    "id":"3",
                    "fieldNo":"F03",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"218",
                    "actualCultivatedArea":0
                },
                {
                    "id":"4",
                    "fieldNo":"F04",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"277",
                    "actualCultivatedArea":0.0719
                },
                {
                    "id":"5",
                    "fieldNo":"F05",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"278",
                    "actualCultivatedArea":0.1417
                },
                {
                    "id":"6",
                    "fieldNo":"F06",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"346",
                    "actualCultivatedArea":0.3405
                },
                {
                    "id":"7",
                    "fieldNo":"F07",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"329",
                    "actualCultivatedArea":0.2864
                }
            ],
            "fieldCrops":[
                {
                    "fieldNos":["F01","F02"],
                    "crops":"包心白菜、結球萵苣",
                    "variety":"高雄149",
                    "estimatedProductionPeriods":["1月","11月","12月"],
                    "plantingMethod":"seed",
                    "seedSources":["selfSeeding"]
                },
                {
                    "fieldNos":["F03","F04","F05"],
                    "crops":"蘿蔔、胡蘿蔔",
                    "variety":"白玉蘿蔔",
                    "estimatedProductionPeriods":["1月","2月","10月","11月","12月"],
                    "plantingMethod":"seedling",
                    "seedSources":["selfSeeding","outsourcing"]
                },
                {
                    "fieldNos":["F03"],
                    "crops":"地瓜",
                    "variety":"台農 157",
                    "estimatedProductionPeriods":["6月","7月","8月","9月","10月"],
                    "plantingMethod":"seed",
                    "seedSources":["selfSeeding"]
                }
            ],
            "confirmStatement1": true,
            "confirmStatement2": true,
            "confirmStatement3": true,
            "confirmStatement4": true,
            "confirmStatement5": true,
            "confirmStatement6": true
        },
        "workflowHistory": [
            {
                "phase": "documentReview",
                "activity": "documentReview_S10",
                "createdOn": "2021/9/10",
                "assigneeName": "王小華",
            },
            {
                "phase": "documentReview",
                "activity": "documentReview_S20",
                "createdOn": "2021/9/10",
                "assigneeName": "張小花",
                "examination": "qualified",
            },
            {
                "phase": "documentReview",
                "activity": "documentReview_S30",
                "createdOn": "2021/9/10",
                "assigneeName": "林小草",
                "examination": "qualified",
            }
        ],
        "documentReview": {
            "documentReviewS10": {
                "documentReviewer": "文審員1"
            },
            "documentReviewS20": {
                "project": "專案2",
                "appCategory": "individual",
                "missingRequiredFiles": {
                    "required2": true,
                    "required4": true,
                    "required2FieldNos": ["F03", "F04"],
                },
                "missingConditionalFiles": ["conditional2"],
                "farmManagementMeetGreenProtection": "Y",
                "harmConservationObject": "N",
                "appliedConservationHabitat": "Y",
                "habitatPlanSuggestion": "Y",
                "examination": "qualified"
            }
        },
        "onsiteInspection": {
            "onsiteInspectionS10": {
                "dispatchMethod": "regional",
                "inspector": "查證員2"
            },
            "onsiteInspectionS30": {
                "visitReportA01": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "A01查訪表單.pdf",
                    "lastModified": 0
                },
                "visitReportA02": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "A02採樣表.pdf",
                    "lastModified": 0
                },
                "visitReportA04": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "A04照片報告.pdf",
                    "lastModified": 0
                },
                "visitReportA03": {
                    "suggestedResult": "belong",
                    "visitMethod": "dedicated"
                },
                "visitReportA06": [
                    {
                        "crop": "作物1",
                        "variety": "品種1",
                        "seedYear": "1",
                        "cultivateFeature": "特性1",
                        "useFeature": "特色1",
                        "applyGreenConservation": true,
                    },
                    {
                        "crop": "作物2",
                        "variety": "品種2",
                        "seedYear": "2",
                        "cultivateFeature": "特性2",
                        "useFeature": "特色3"
                    }
                ],
            }
        },
        "inspectionReview": {
            "inspectionReviewS10": {
                "reviewMethod": "headquarter"
            },
            "inspectionReviewS20": {
                "region": "north",
                "reviewer": "查證員13"
            },
            "inspectionReviewS30": {
                "reminderInspector": "整個規劃很棒，充分運用各種資源",
                "suggestion": "沒有建議",
                "reviewResult": "pass",
                "drugTestResult": "pass",
                "drugTestReport": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "A05藥檢報告.pdf",
                    "lastModified": 0
                }
            },
            "inspectionReviewS40": {
                "examination": "pass"
            }
        },
        "recheckReview": {
            "recheckReviewS10": {
                "speculateReason": "農藥施放時僅少部份殘留在目標作物上，達到防治或調節效果，大部份會經由蒸發、飄散、沉降、淋洗、溢流、滲濾、吸附及攝食而分別進入空氣、土壤、河川及生物鏈中。",
                "speculateReasonAttachment": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "推測檢出原因.pdf",
                    "lastModified": 0
                },
                "improvement": "農藥施放時僅少部份殘留在目標作物上，達到防治或調節效果，大部份會經由蒸發、飄散、沉降、淋洗、溢流、滲濾、吸附及攝食而分別進入空氣、土壤、河川及生物鏈中。",
                "improvementAttachment": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "改善方式.pdf",
                    "lastModified": 0
                }
            },
            "recheckReviewS20": {
                "reviewOpinion": "農藥施放時僅少部份殘留在目標作物上，達到防治或調節效果，大部份會經由蒸發、飄散、沉降、淋洗、溢流、滲濾、吸附及攝食而分別進入空氣、土壤、河川及生物鏈中。"
            },
            "recheckReviewS30": {
                "examination": "pass"
            },
            "recheckReviewS40": {
                "visitReport": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "採樣記錄表.pdf",
                    "lastModified": 0
                },
                "photoReport": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "照片報告.pdf",
                    "lastModified": 0
                },
            },
            "recheckReviewS50": {
                "drugTestResult": "fail",
                "drugTestReport": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "A05藥檢報告.pdf",
                    "lastModified": 0
                },
            }
        }
    },
    {
        "id": "2",
        "createdOn":"2021-01-05T08:20:10.000Z",
        "stayDays": 9,
        "appNo":"CGA00150-C-00-002",
        "type":"regular1",
        "phase":"documentReview",
        "activity":"documentReview_S30",
        "farmerNo":"CGA00150",
        "appStatus": "open",
        "farmerName":"王森林",
        "phone": "03-2919-1649",
        "mobilePhone": "0902192521",
        "assignee": "郭淑娟",
        "greenConservationLiaison": "王小保",
        "cropApplication": {
            "id":"2",
            "applicant":"王森林",
            "idNo": "A123456789",
            "farmName": "興興",
            "applicantType": "individual",
            "gender": "male",
            "birthday": "1979/03/23",
            "phone": "03-2919-1649",
            "contactPerson": "王大濃",
            "farmType": ["production"],
            "applyApprovedProcessing": true,
            "contactPersonPhone": "0902192521",
            "conservationTarget": "species2",
            "species": "青蛙",
            "category":"crop",
            "type":"initial",
            "createdOn":"2021-05-12T08:20:10.000Z",
            "totalImplementationArea":1.1678,
            "nonGreenArea": 0.345,
            "fieldLands":[
                {
                    "id":"1",
                    "fieldNo":"F01",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"249",
                    "actualCultivatedArea":0.2968
                },
                {
                    "id":"2",
                    "fieldNo":"F02",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"246",
                    "actualCultivatedArea":0.0305
                },
                {
                    "id":"3",
                    "fieldNo":"F03",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"218",
                    "actualCultivatedArea":0
                },
                {
                    "id":"4",
                    "fieldNo":"F04",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"277",
                    "actualCultivatedArea":0.0719
                },
                {
                    "id":"5",
                    "fieldNo":"F05",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"278",
                    "actualCultivatedArea":0.1417
                },
                {
                    "id":"6",
                    "fieldNo":"F06",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"346",
                    "actualCultivatedArea":0.3405
                },
                {
                    "id":"7",
                    "fieldNo":"F07",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"329",
                    "actualCultivatedArea":0.2864
                }
            ],
            "fieldCrops":[
                {
                    "fieldNos":["F01","F02"],
                    "crops":"包心白菜、結球萵苣",
                    "variety":"高雄149",
                    "estimatedProductionPeriods":["1月","11月","12月"],
                    "plantingMethod":"seed",
                    "seedSources":["selfSeeding"]
                },
                {
                    "fieldNos":["F03","F04","F05"],
                    "crops":"蘿蔔、胡蘿蔔",
                    "variety":"白玉蘿蔔",
                    "estimatedProductionPeriods":["1月","2月","10月","11月","12月"],
                    "plantingMethod":"seedling",
                    "seedSources":["selfSeeding","outsourcing"]
                },
                {
                    "fieldNos":["F03"],
                    "crops":"地瓜",
                    "variety":"台農 157",
                    "estimatedProductionPeriods":["6月","7月","8月","9月","10月"],
                    "plantingMethod":"seed",
                    "seedSources":["selfSeeding"]
                }
            ],
            "confirmStatement1": true,
            "confirmStatement2": true,
            "confirmStatement3": true,
            "confirmStatement4": true,
            "confirmStatement5": true,
            "confirmStatement6": true
        },
        "workflowHistory": [
            {
                "phase": "documentReview",
                "activity": "documentReview_S10",
                "createdOn": "2021/9/10",
                "assigneeName": "王小華",
            },
            {
                "phase": "documentReview",
                "activity": "documentReview_S20",
                "createdOn": "2021/9/10",
                "assigneeName": "張小花",
                "examination": "qualified",
            }
        ],
        "documentReview": {
            "documentReviewS10": {
                "documentReviewer": "文審員1"
            },
            "documentReviewS20": {
                "project": "專案2",
                "appCategory": "individual",
                "missingRequiredFiles": {
                    "required1": true,
                    "required2": true,
                    "required1FieldNos": ["F03", "F04"],
                    "required2FieldNos": ["F01", "F02"]
                },
                "missingConditionalFiles": ["conditional2"],
                "farmManagementMeetGreenProtection": "Y",
                "harmConservationObject": "N",
                "appliedConservationHabitat": "Y",
                "habitatPlanSuggestion": "Y",
                "examination": "qualified"
            }
        }
    },
    {
        "id": "3",
        "createdOn":"2021-03-16T08:20:10.000Z",
        "stayDays": 2,
        "appNo":"CGB00097-C-00-002",
        "type":"reEvaluation",
        "phase":"inspectionReview",
        "activity":"inspectionReview_S30",
        "farmerNo":"CGA00150",
        "appStatus": "open",
        "farmerName":"李小異",
        "phone": "02-2992-5221",
        "mobilePhone": "0912170419",
        "assignee": "溫婷安",
        "greenConservationLiaison": "王小保",
        "cropApplication": {
            "id":"3",
            "applicant":"李小異",
            "idNo": "A123456789",
            "farmName": "興興",
            "applicantType": "individual",
            "gender": "male",
            "birthday": "1979/03/23",
            "phone": "02-2992-5221",
            "contactPerson": "王大濃",
            "farmType": ["production"],
            "applyApprovedProcessing": true,
            "contactPersonPhone": "0912170419",
            "conservationTarget": "species2",
            "species": "青蛙",
            "category":"crop",
            "type":"initial",
            "createdOn":"2021-05-12T08:20:10.000Z",
            "totalImplementationArea":1.1678,
            "nonGreenArea": 0.345,
            "fieldLands":[
                {
                    "id":"1",
                    "fieldNo":"F01",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"249",
                    "actualCultivatedArea":0.2968
                },
                {
                    "id":"2",
                    "fieldNo":"F02",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"246",
                    "actualCultivatedArea":0.0305
                },
                {
                    "id":"3",
                    "fieldNo":"F03",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"218",
                    "actualCultivatedArea":0
                },
                {
                    "id":"4",
                    "fieldNo":"F04",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"277",
                    "actualCultivatedArea":0.0719
                },
                {
                    "id":"5",
                    "fieldNo":"F05",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"278",
                    "actualCultivatedArea":0.1417
                },
                {
                    "id":"6",
                    "fieldNo":"F06",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"346",
                    "actualCultivatedArea":0.3405
                },
                {
                    "id":"7",
                    "fieldNo":"F07",
                    "city":"64",
                    "district":"美濃區",
                    "landLot":"廣林段",
                    "landSerialNo":"329",
                    "actualCultivatedArea":0.2864
                }
            ],
            "fieldCrops":[
                {
                    "fieldNos":["F01","F02"],
                    "crops":"包心白菜、結球萵苣",
                    "variety":"高雄149",
                    "estimatedProductionPeriods":["1月","11月","12月"],
                    "plantingMethod":"seed",
                    "seedSources":["selfSeeding"]
                },
                {
                    "fieldNos":["F03","F04","F05"],
                    "crops":"蘿蔔、胡蘿蔔",
                    "variety":"白玉蘿蔔",
                    "estimatedProductionPeriods":["1月","2月","10月","11月","12月"],
                    "plantingMethod":"seedling",
                    "seedSources":["selfSeeding","outsourcing"]
                },
                {
                    "fieldNos":["F03"],
                    "crops":"地瓜",
                    "variety":"台農 157",
                    "estimatedProductionPeriods":["6月","7月","8月","9月","10月"],
                    "plantingMethod":"seed",
                    "seedSources":["selfSeeding"]
                }
            ],
            "confirmStatement1": true,
            "confirmStatement2": true,
            "confirmStatement3": true,
            "confirmStatement4": true,
            "confirmStatement5": true,
            "confirmStatement6": true
        },
        "workflowHistory": [
            {
                "phase": "documentReview",
                "activity": "documentReview_S10",
                "createdOn": "2021/9/10",
                "assigneeName": "王小華",
            },
            {
                "phase": "documentReview",
                "activity": "documentReview_S20",
                "createdOn": "2021/9/10",
                "assigneeName": "張小花",
                "examination": "qualified",
            },
            {
                "phase": "documentReview",
                "activity": "documentReview_S30",
                "createdOn": "2021/9/10",
                "assigneeName": "林小草",
                "examination": "qualified",
            }
        ],
        "documentReview": {
            "documentReviewS10": {
                "documentReviewer": "文審員1"
            },
            "documentReviewS20": {
                "project": "專案2",
                "appCategory": "individual",
                "missingRequiredFiles": {
                    "required1": true,
                    "required3": true,
                    "required1FieldNos": ["F03", "F04"],
                },
                "missingConditionalFiles": ["conditional2"],
                "farmManagementMeetGreenProtection": "Y",
                "harmConservationObject": "N",
                "appliedConservationHabitat": "Y",
                "habitatPlanSuggestion": "Y",
                "examination": "qualified"
            }
        },
        "onsiteInspection": {
            "onsiteInspectionS10": {
                "dispatchMethod": "regional",
                "inspector": "查證員2"
            },
            "onsiteInspectionS30": {
                "visitReportA01": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "A01查訪表單.pdf",
                    "lastModified": 0
                },
                "visitReportA02": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "A02採樣表.pdf",
                    "lastModified": 0
                },
                "visitReportA04": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "A04照片報告.pdf",
                    "lastModified": 0
                },
                "visitReportA03": {
                    "suggestedResult": "belong",
                    "visitMethod": "dedicated"
                },
                "visitReportA06": [
                    {
                        "crop": "作物1",
                        "variety": "品種1",
                        "seedYear": "1",
                        "cultivateFeature": "特性1",
                        "useFeature": "特色1",
                        "applyGreenConservation": true,
                    },
                    {
                        "crop": "作物2",
                        "variety": "品種2",
                        "seedYear": "2",
                        "cultivateFeature": "特性2",
                        "useFeature": "特色3"
                    }
                ],
            }
        },
        "inspectionReview": {
            "inspectionReviewS10": {
                "reviewMethod": "headquarter"
            },
            "inspectionReviewS20": {
                "region": "north",
                "reviewer": "查證員13"
            },
            "inspectionReviewS30": {
                "reminderInspector": "整個規劃很棒，充分運用各種資源",
                "suggestion": "沒有建議",
                "reviewResult": "pass",
                "drugTestResult": "pass",
                "drugTestReport": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "A05藥檢報告.pdf",
                    "lastModified": 0
                }
            }
        }
    }
];

export default cropApplication;